(function () {
  function initReviewsSlider() {
    var sliders = document.querySelectorAll('.reviewSwiper');
    if (!sliders.length) return;
    swiperCheckAndLoad();
    var attempts = 0;
    function start() {
      if (typeof Swiper === 'undefined') {
        if (++attempts < 100) setTimeout(start, 100);
        return;
      }
      sliders.forEach(function (slider) {
        if (slider.swiper) return;
        new Swiper(slider, {
          slidesPerView: 'auto', spaceBetween: 15, loop: true,
          speed: parseInt(slider.dataset.speed || 5000, 10),
          autoplay: { delay: 1, disableOnInteraction: false },
          allowTouchMove: true, grabCursor: true,
          freeMode: { enabled: false }
        });
      });
    }
    start();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReviewsSlider);
  else initReviewsSlider();
  document.addEventListener('shopify:section:load', initReviewsSlider);
})();
function scrollToTop(event) {
  event.preventDefault();
  window.scrollTo({ top: 0, behavior: 'smooth' });
}
